import { j as n } from "./atoms-v218.js";
import { forwardRef as i } from "react";
import { Specs as S, Spec as f } from "./atoms-v2736.js";
import { getChildrenByTypeDeep as h } from "./atoms-v2737.js";
const s = i(
  ({ children: e, className: o, colorTheme: p = "light", id: r, variant: t = "horizontal", ...c }, a) => {
    const m = h(e, ["Icon"]).length > 0;
    return /* @__PURE__ */ n.jsx(
      S,
      {
        $colorTheme: p,
        $hasIcons: m,
        $variant: t,
        className: o,
        id: r,
        ref: a,
        ...c,
        children: e
      }
    );
  }
);
s.displayName = "Specs";
const $ = Object.assign(s, {
  Spec: f
});
export {
  $ as Specs
};
